module.exports = __webpack_public_path__ + "img/titimg1.c377fe24.png";